import React, { useState } from "react";
import {
  View,
  ScrollView,
  ToastAndroid,
  TouchableOpacity} from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import commonStyles from "../../../styles/commonStyles";
import OverflowTooltipText from "../../../components/OverflowTooltipText";

import { IBankDetails } from "../../../types/IBankDetailsType";
import * as Clipboard from "expo-clipboard";
import Feather from "@expo/vector-icons/Feather";
import Toast from "react-native-toast-message";
import { SafeAreaView } from "react-native-safe-area-context";
import AppText from "../../../components/AppText";

type BankDetailsProps = {
  navigation: NativeStackNavigationProp<any>;
  route: {
    params: {
      bankDetails: IBankDetails;
    };
  };
};

const InvestmentBankDetails: React.FC<BankDetailsProps> = ({
  navigation,
  route}) => {

  const [copiedText, setCopiedText] = useState("");

  const fetchCopiedText = async () => {
    const text = await Clipboard.getStringAsync();
    setCopiedText(text);
  };
  const showToast = () => {
    Toast.show({
      type: "success",
      text1: "Bank Detail",
      text2: "Copied to clipboard"});
  };

  const { bankDetails } = route.params;
  const fullAddress = [
    bankDetails.entityAddress.street1,
    bankDetails.entityAddress.city,
    bankDetails.entityAddress.state,
    bankDetails.entityAddress.zipCode,
  ]
    .filter(Boolean)
    .join(", ");

  const clipBoard =
    "Entity Name - " +
    bankDetails.name +
    "\n" +
    "EIN - " +
    bankDetails.ein +
    "\n" +
    "Entity Address - " +
    bankDetails.entityAddress.street1 +
    " " +
    bankDetails.entityAddress.street2 +
    " " +
    bankDetails.entityAddress.city +
    " " +
    bankDetails.entityAddress.state +
    " " +
    bankDetails.entityAddress.zipCode +
    "\n" +
    "Bank - " +
    bankDetails.entityBankDetails.bankName +
    " " +
    "\n" +
    "Address - " +
    bankDetails.entityBankDetails.address.street1 +
    " " +
    bankDetails.entityBankDetails.address.street2 +
    " " +
    bankDetails.entityBankDetails.address.city +
    " " +
    bankDetails.entityBankDetails.address.state +
    " " +
    bankDetails.entityBankDetails.address.zipCode +
    "\n" +
    "Account# - " +
    bankDetails.entityBankDetails.accountNumber +
    "\n" +
    "ACH Routing# - " +
    bankDetails.entityBankDetails.achRoutingNumber +
    "\n" +
    "Wire Routing# - " +
    bankDetails.entityBankDetails.wireRoutingNumber;

  const copyToClipboard = async () => {
    await Clipboard.setStringAsync(clipBoard);
    showToast();
  };
  return (
    <SafeAreaView edges={[ "bottom", "left", "right"]} style={[{ flex: 1}, commonStyles.screenBottomGap]}>
      <View style={commonStyles.container}>
        <View style={[commonStyles.flexSpaceBetween, commonStyles.fw]}>
          <TouchableOpacity
            onPress={() => navigation.goBack()}
            style={commonStyles.subHeaderContainer}
          >
            <AntDesign name="left" size={24} color="black" />
            <AppText style={commonStyles.subHeader}>Bank Details</AppText>
          </TouchableOpacity>
          <View>
            <Feather
              name="copy"
              size={24}
              color="black"
              onPress={() => copyToClipboard()}
            />
          </View>
        </View>
        <ScrollView>
          <View
            style={[
              commonStyles.subContainer,
              commonStyles.p14,
              commonStyles.mt5,
              commonStyles.mlar2,
            ]}
          >
            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>Entity Name</AppText>
              <OverflowTooltipText
              testID="entityName"
                text={bankDetails.name}
                style={commonStyles.subValue}
                containerWidth="70%"
              />
            </View>
            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>EIN</AppText>
              <AppText style={commonStyles.subValue} testID="ein">{bankDetails.ein}</AppText>
            </View>
            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>Entity Address</AppText>

              <OverflowTooltipText
              testID="entityAddress"
                text={fullAddress}
                style={commonStyles.subValue}
                containerWidth="65%"
              />
            </View>
            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>Bank Name</AppText>
              <AppText style={commonStyles.subValue} testID="bankName">
                {bankDetails.entityBankDetails.bankName}
              </AppText>
            </View>
            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>Bank Address</AppText>
              <OverflowTooltipText
              testID="bankAddress"
                text={[
                  bankDetails.entityBankDetails.address.street1,
                  bankDetails.entityBankDetails.address.city,
                  bankDetails.entityBankDetails.address.state,
                  bankDetails.entityBankDetails.address.zipCode,
                ]
                  .filter(Boolean)
                  .join(", ")}
                style={commonStyles.subValue}
                containerWidth="65%"
              />
            </View>

            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>Zelle ID</AppText>
              <AppText style={commonStyles.subValue}></AppText>
              <OverflowTooltipText
              testID="zelleId"
                text={bankDetails.entityBankDetails.zelleId}
                style={commonStyles.subValue}
                containerWidth="60%"
              />
            </View>
            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>Account Number</AppText>
              <AppText style={commonStyles.subValue} testID="accountNumber">
                {bankDetails.entityBankDetails.accountNumber}
              </AppText>
            </View>
            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>ACH Routing #</AppText>
              <AppText style={commonStyles.subValue} testID="achRoutingNumber">
                {bankDetails.entityBankDetails.achRoutingNumber}
              </AppText>
            </View>
            <View style={commonStyles.subDetails}>
              <AppText style={commonStyles.subTitle}>Wire Routing #</AppText>
              <AppText style={commonStyles.subValue} testID="wireRoutingNumber">
                {bankDetails.entityBankDetails.wireRoutingNumber}
              </AppText>
            </View>
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

export default InvestmentBankDetails;
